import styled from '@emotion/styled';
import { icons, theme } from '@ublend-npm/aulaui-next';

export const AssignmentsListWrapper = styled.div`
  height: 328px;
  width: 420px;
  text-align: center;
`;

export const AssignmentsListWrapperWithPadding = styled(AssignmentsListWrapper)`
  padding-top: ${theme.spacing.xLarge};
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify: center;
  justify-content: center;
`;

export const WarningIcon = styled(icons.WarningIcon)`
  color: ${theme.color.designSystem.blackOpacity60};
  padding-right: ${theme.spacing.xSmall};
`;

export const Text = styled.span`
  color: ${theme.color.designSystem.blackOpacity87};
  font-size: ${theme.font.size.copy};
`;

export const ButtonLinkWrapper = styled.span`
  margin-top: ${theme.spacing.xxxSmall};
  padding-right: ${theme.spacing.xSmall};
`;

export const EmptyAssignmentTextWrapper = styled.div`
  margin-bottom: ${theme.spacing.xLarge};
`;
